<template>
  <div>
    <Head title="Users" />
    <div class="flex flex-row mb-8">
      <h1 class="text-3xl font-bold mr-5 flex flex-row items-center">
        Utilizator: {{ user.name }}
        <icon
          v-if="user.deleted_at"
          name="trash"
          class="ml-2 h-8 w-8 shrink-0 fill-red-500"
        />
      </h1>
      <Link class="btn-teal" :href="$routes.edit_user(user.id)">
        Editeaza date personale
      </Link>
    </div>
    <div class="shadow-sm rounded-sm">
      <p class="p-2 mb-2 bg-white">Email: {{ user.email }}</p>
      <p class="p-2 mb-2 bg-white">Telefon: {{ user.telephone }}</p>
      <p class="p-2 mb-2 bg-white">Companie: {{ user.company }}</p>
      <p class="p-2 mb-2 bg-white">
        Ultima activitate: {{ formatDateTime(user.last_activity) }}
      </p>
    </div>

    <div class="flex flex-row mb-5 mt-8 items-center">
      <h1 class="text-3xl font-bold">Cursuri</h1>
      <Link class="btn-teal ml-5" :href="`/users/${user.id}/user_courses/new`">
        Aloca curs nou
      </Link>
    </div>
    <div class="overflow-x-auto rounded-sm bg-white shadow-sm">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pr-35 pb-4 pt-6 pl-2">Nume</th>
            <th class="pr-6 pb-4 pt-6 pl-8">Tip</th>
            <th class="pr-6 pb-4 pt-6 pl-2">Status</th>
            <th class="pr-2 pb-4 pt-6 pl-2">Inceput la</th>
            <th class="pr-8 pb-4 pt-6 pl-2">Pana la</th>
            <th class="pr-6 pb-4 pt-6 pl-2">%</th>
            <th class="pb-4 pt-6 pl-2">Actiuni</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="user_course in user.user_courses"
            :key="user_course.id"
            class="focus-within:bg-gray-100 hover:bg-gray-100"
          >
            <td class="border-t pl-2 py-2 max-w-80">
              <div class="truncate" :title="user_course.course.name">
                {{ user_course.course.name }}
              </div>
            </td>
            <td class="border-t pl-8">
              {{ user_course.course.type }}
            </td>
            <td class="border-t pl-2">
              {{ formatStatus(user_course.status) }}
            </td>
            <td class="border-t pl-2">
              <div class="flex flex-col">
                <span :class="user_course.rescheduled ? 'line-through' : ''">{{
                  formatDate(user_course.start_date)
                }}</span>
                <span v-if="user_course.rescheduled">{{
                  formatDate(user_course.restart_start_date)
                }}</span>
              </div>
            </td>
            <td class="border-t pl-2">
              <div class="flex flex-col">
                <span :class="user_course.rescheduled ? 'line-through' : ''">{{
                  formatDate(user_course.end_date)
                }}</span>
                <span v-if="user_course.rescheduled">{{
                  formatDate(user_course.restart_end_date)
                }}</span>
              </div>
            </td>
            <td class="border-t pl-2">
              <span v-if="user_course.completion !== undefined">
                {{ user_course.completion }}%
              </span>
              <span v-else class="text-gray-400">-</span>
            </td>
            <td class="border-t p-2">
              <div class="flex gap-2 items-center">
                <Button
                  icon="pi pi-pen-to-square"
                  class="btn-teal btn-small"
                  severity="info"
                  text
                  size="small"
                  @click="
                    $inertia.visit(`/user_courses/${user_course.id}/edit`)
                  "
                />
                <Button
                  icon="pi pi-trash"
                  class="btn-red btn-small"
                  severity="danger"
                  text
                  size="small"
                  @click="destroyUserCourse(user_course.id)"
                />
              </div>
            </td>
          </tr>
          <tr v-if="user.user_courses.length === 0">
            <td class="border-t px-6 py-4" colspan="7">
              Acest utilizator nu are nici un curs momentan.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3';
import Layout from '@/Layouts/Main.vue';

// Removed modal-based new/edit for user courses; using full pages now.
import Icon from '@/Shared/Icon.vue';
import Button from 'primevue/button';
import { formatDate, formatStatus, formatDateTime } from '@/utils/formatters';

export default {
  components: {
    Head,
    Link,
    Icon,
    Button,
  },
  layout: Layout,
  props: {
    user: {
      type: Object,
      required: true,
    },
    availableCourses: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      // modal state removed; navigation goes to full pages
    };
  },
  methods: {
    formatDate,
    formatStatus,
    formatDateTime,
    async destroyUserCourse(userCourseId) {
      if (
        confirm(
          'Esti sigur(a) ca vrei sa stergi cursul acesta de la acest user?',
        )
      ) {
        this.$inertia.delete(this.$routes.user_course(userCourseId));
      }
    },
  },
};
</script>
